import I18n from './steady_gettext';
import translations from './translations';
const i18n = I18n({});
const messages = translations.messages;
const locales = Object.keys(messages);
locales.forEach(locale => {
    const localeMessages = messages[locale] || {};
    i18n.setMessages(locale, localeMessages, translations.headers[locale]['Plural-Forms']);
});
// Exported functions must be named $gettext, $ngettext, $dgettext, and $pgettext
// because the library easygettext extracts messages from functions named like that
// (see https://github.com/polyconseil/easygettext#javascriptes7-token-extraction),
// and we also configured react-gettext-parser to use the same names
// (see react-gettext-parser.config.js).
export default i18n;
